<!--
 * @Author: ZS
 * @Date: 2020-06-09 14:44:54
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-15 16:30:55
 * @Description: file content
-->
<template>
  <div>
    <div class="mainContent topPart" v-cloak>
      <v-header></v-header>
      <v-nav :index="navIndex"></v-nav>
      <div class="topQuery">
        <div class="clearfix mainWidth">
          <div class="left pull-left">
            <v-searchBar></v-searchBar>
            <div class="hotIssues">
              <p class="tit clearfix">
                <span>
                  <i class="iconfont icon-tongzhi"></i>
                  办事动态
                </span>
                <a
                  class="more pull-right"
                  :href="newsMore"
                  style="color: #d90000"
                  target="_blank"
                  >更多&gt;</a
                >
              </p>
              <ul class="clearfix">
                <li
                  v-for="(item, index) in newsList"
                  :key="index"
                  @click="newsJump(item.href)"
                >
                  <i></i><span>{{ item.title }}</span
                  ><b>{{ item.newDate }}</b>
                </li>
              </ul>
              <div class="noData bsqsData" v-if="noBs">
                <img src="../../assets/images/bsqs.png" alt="" />
                <p>暂无办事动态</p>
              </div>
            </div>
          </div>
          <div
            class="right pull-right notLogin"
            style="display: block"
            v-if="!$store.state.isLogin"
          >
            <h3 class="tit">办事直达</h3>
            <div class="directBox clearfix">
              <div class="box1">
                <h5 class="tit">
                  按部门
                  <span class="hover_wrap">
                    <img
                      src="../../assets/images/redarrow.png"
                      alt=""
                      class="hover_target_wrap"
                    />
                    <div class="directHoverlist">
                      <div class="redTriangle"></div>
                      <ul class="clearfix">
                        <li
                          v-for="(item, index) in departList"
                          :key="index"
                          @click="goDepartPage(item.deptName, item.deptCode)"
                          :title="item.deptName"
                        >
                          {{ item.deptName }}
                        </li>
                      </ul>
                    </div>
                  </span>
                </h5>
                <ul class="overflowHidden">
                  <li
                    v-for="(item, index) in departList"
                    :key="index"
                    @click="goDepartPage(item.deptName, item.deptCode)"
                    :title="item.deptName"
                  >
                    <i></i>{{ item.deptName }}
                  </li>
                </ul>
              </div>
              <div class="box2">
                <h5 class="tit">
                  按主题
                  <span class="hover_wrap">
                    <img
                      src="../../assets/images/redarrow.png"
                      alt=""
                      class="hover_target_wrap"
                    />
                    <div class="directHoverlist theme_wrap">
                      <div class="redTriangle"></div>
                      <ul class="overflowHidden">
                        <li
                          v-for="(item, index) in ztList"
                          :key="index"
                          @click="
                            byTheme(
                              item.pcGuidelineSceneCode,
                              item.pcGuidelineSceneParentCode
                            )
                          "
                        >
                          <i></i>{{ item.pcGuidelineSceneName }}
                        </li>
                      </ul>
                    </div>
                  </span>
                </h5>
                <ul class="overflowHidden">
                  <li
                    v-for="(item, index) in ztList"
                    :key="index"
                    @click="
                      byTheme(
                        item.pcGuidelineSceneCode,
                        item.pcGuidelineSceneParentCode
                      )
                    "
                  >
                    <i></i>{{ item.pcGuidelineSceneName }}
                  </li>
                </ul>
              </div>
              <div class="box3">
                <img src="../../assets/images/yjsycb1.png" alt="" />
                <div class="appQrcode">
                  <img src="../../assets/images/code-syb.png" alt="" />
                  <p>扫描左侧二维码<br />下载i轻工大APP</p>
                  <div class="downLoadNowBtn" @click="downloadAppFunc">
                    立即下载<i class="iconfont icon-shou"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="right pull-right logined"
            style="display: block"
            v-if="$store.state.isLogin"
          >
            <div class="bszd pull-left">
              <h3 class="tit">办事直达</h3>
              <ul class="clearfix">
                <li data-code="bySector">
                  <div class="iconfont icon-anbumen"></div>
                  <p>按部门</p>
                  <div class="directHoverlist">
                    <div class="redTriangle"></div>
                    <ul class="clearfix">
                      <li
                        v-for="(item, index) in departList"
                        :key="index"
                        @click="goDepartPage(item.deptName, item.deptCode)"
                        :title="item.deptName"
                      >
                        {{ item.deptName }}
                      </li>
                    </ul>
                  </div>
                </li>
                <li data-code="byScene">
                  <div class="iconfont icon-zhuti1"></div>
                  <p>按主题</p>
                  <div class="directHoverlist">
                    <div class="redTriangle"></div>
                    <ul class="clearfix">
                      <li
                        v-for="(item, index) in ztList"
                        :key="index"
                        @click="
                          byTheme(
                            item.pcGuidelineSceneCode,
                            item.pcGuidelineSceneParentCode
                          )
                        "
                      >
                        {{ item.pcGuidelineSceneName }}
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
            <div class="grxx pull-left">
              <div class="ywtbUserInfo">
                <a href="javascript:void(0)" class="user-photo-wrap">
                  <img
                    class="userPhoto"
                    src="/portal-ywtb/web/userProFile/getUserProfile"
                  />
                </a>
                <p class="name">{{ $store.state.nickName }}</p>
                <div class="role clearfix">
                  <span v-for="(item, index) in roleNameList" :key="index">{{
                    item.roleName
                  }}</span>
                </div>
                <div
                  class="dPart"
                  v-for="(item, index) in $store.state.departName"
                  :key="index"
                >
                  {{ item.deptName }}
                </div>
                <div class="myHomepage" @click="goUser()">个人中心</div>
              </div>
              <ul class="userMatterList clearfix">
                <li @click="goUser(4, 0)">
                  <div class="num">{{ userNums.wddb }}</div>
                  <p>我的待办</p>
                </li>
                <li @click="goUser(0, 0)">
                  <div class="num">{{ userNums.blz }}</div>
                  <p>办理中</p>
                </li>
                <li class="myAdvisory" @click="goUser(0, 1)">
                  <div class="num">{{ userNums.ybj }}</div>
                  <p>已办结</p>
                </li>
                <li @click="goUser(1, 0)" class="marginR0">
                  <div class="num">{{ userNums.wdzx }}</div>
                  <p>我的咨询</p>
                </li>
                <li v-show="false">
                  <div class="num">0</div>
                  <p>我的消息</p>
                </li>
              </ul>
              <div style="overflow: hidden; height: 120px">
                <v-userTip :num="5"></v-userTip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mainWidth typeOfService">
      <ul class="clearfix serviceTitle">
        <li
          v-for="(item, index) in typeOfService"
          :key="index"
          :class="{
            active: serviceIndex === index,
            serviceTitle_li: item.isShow === true,
          }"
          @click="changeService(index, item.isShow)"
          @mouseenter="mouseenter(item.sname, index, item.isShow)"
          :title="[item.isShow ? '' : '暂无适用您的相关事项服务']"
        >
          <h3 class="serTypeTit">{{ item.sname }}<span>&gt;</span></h3>
          <p>{{ item.description }}</p>
          <div class="subNum clearfix">
            <div class="stuNum">
              <p>{{ item.fwcs || 0 }}</p>
              <span>访问次数</span>
            </div>
            <div>
              <p>{{ item.ybj || 0 }}</p>
              <span>已办结</span>
            </div>
            <div>
              <p>{{ item.blz || 0 }}</p>
              <span>办理中</span>
            </div>
          </div>
          <div class="serTotalNum">
            <b>{{ item.totalNum || 0 }}</b
            >项
          </div>
          <img :src="item.imgUrl" alt="" />
          <!-- <div class="serviceTriangle"></div> -->
        </li>
      </ul>
      <div class="serviceContent" v-if="getGuidelineList.length">
        <transition-group name="list-complete">
          <div
            v-for="(el, Findex) in getGuidelineList"
            class="serviceContentBox studentService"
            v-if="listFlag"
            :key="el.pcGuidelineSceneId"
            v-show="roleAuthFlag[el.index]"
          >
            <div class="TabTit">
              <dl class="clearfix">
                <dt>
                  <img
                    :src="`../../../static/images/titleicon${
                      typeOfService.findIndex(
                        (n) => n.sname == el.pcGuidelineSceneName
                      ) + 1
                    }.png`"
                    alt=""
                  />
                  {{ el.pcGuidelineSceneName }}
                </dt>
                <dd
                  v-for="(item, index) in el.sceneList"
                  :key="index"
                  :class="[
                    `active_${
                      typeOfService.findIndex(
                        (n) => n.sname == el.pcGuidelineSceneName
                      ) + 1
                    }`,
                    {
                      active: ReturnTable(el.index) === index,
                    },
                  ]"
                  @click="
                    tab0click(
                      el.index,
                      index,
                      item.pcGuidelineSceneCode,
                      item.pcGuidelineSceneParentCode
                    )
                  "
                >
                  {{ item.pcGuidelineSceneName }}
                </dd>
              </dl>
            </div>
            <div class="tabContent" v-if="el.sceneList.length > 0">
              <ul
                class="clearfix"
                v-for="(item, index) in el.sceneList"
                :key="index"
                v-if="ReturnTable(el.index) === index"
              >
                <li
                  v-for="(item1, index) in item.guidelineList"
                  :key="index"
                  @click="viewGuide(item1, item1.portalPcHandlingGuidelineCode)"
                >
                  <img
                    :src="item1.portalPcHandlingGuidelineImg"
                    alt=""
                    class="guideline_image"
                  />
                  <div class="mutil-line-ellipsis">
                    <p class="guideline_name_wrap">
                      {{ item1.portalPcHandlingGuidelineName }}
                    </p>
                  </div>

                  <i
                    class="iconfont icon-sc"
                    :class="[
                      {
                        active: item1.portalPcHandlingGuidelineCollection == 1,
                      },
                    ]"
                    v-if="$store.state.isLogin"
                    @click="publicJs.collection(item1)"
                  ></i>
                </li>
                <li
                  v-if="!loginState && item.guidelineList.length > 0"
                  @click="
                    viewMore(
                      `${
                        el.index == 0 ? cCode0 : el.index == 1 ? cCode1 : cCode2
                      }`,
                      `${
                        el.index == 0 ? pCode0 : el.index == 1 ? pCode1 : pCode2
                      }`
                    )
                  "
                >
                  <img src="../../assets/images/more.png" alt="" />
                  <p>查看更多</p>
                </li>
                <div class="nullData" v-if="item.guidelineList.length == 0">
                  <img src="../../../static/images/yyqs.png" alt="" />
                  <p>暂无适用您的相关事项服务</p>
                </div>
              </ul>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <Fwcxtj></Fwcxtj>
    <v-footer></v-footer>
    <v-toolBar></v-toolBar>
  </div>
</template>

<script>
import Footer from "../common/Footer";
import Header from "../common/Header";
import TopNav from "../common/TopNav";
import ToolBar from "../common/ToolBar";
import UserTip from "../page/home/UserTip";
import SearchBar from "../page/home/SearchBar";
import HomeMixin from "./home-mixin.js";
import qs from "qs";
import Fwcxtj from "./Fwcxtj.vue";
import { request } from "@/api/axios.js";
export default {
  components: {
    "v-footer": Footer,
    "v-header": Header,
    "v-nav": TopNav,
    "v-toolBar": ToolBar,
    "v-userTip": UserTip,
    "v-searchBar": SearchBar,
    Fwcxtj,
  },
  mixins: [HomeMixin],
  computed: {
    roleNameList() {
      const list = this.$store.state.roleName || [];
      const arr = list.filter((item) => item.roleType !== "2");
      return arr;
    },
  },
  data() {
    return {
      listFlag: false,
      userId: 1000,
      nickName: "李四",
      rolename: "管理员",
      departName: "信息管理中心",
      serviceIndex: "", //三个服务索引
      typeOfService: [
        {
          sname: "学生服务",
          description: "提供学生相关的各类办事服务",
          imgUrl: require("../../assets/images/serviceTit1.png"),
          totalNum: 0,
          fwcs: 0,
          ybj: 0,
          blz: 0,
        },
        {
          sname: "教职工服务",
          description: "提供教职工相关的各类办事服务",
          imgUrl: require("../../assets/images/serviceTit2.png"),
          totalNum: 0,
          fwcs: 0,
          ybj: 0,
          blz: 0,
        },
        {
          sname: "公众服务",
          description: "提供公众相关的各类办事服务",
          imgUrl: require("../../assets/images/serviceTit3.png"),
          totalNum: 0,
          fwcs: 0,
          ybj: 0,
          blz: 0,
        },
      ],
      navIndex: 0,
      departList: [], //部门列表
      roleList: [],
      TabTitIdx0: 0,
      TabTitIdx1: 0,
      TabTitIdx2: 0,
      inputVal: "",
      ztList: "",
      getGuidelineList: [],
      cCode0: "",
      pCode0: "",
      cCode1: "",
      pCode1: "",
      cCode2: "",
      pCode2: "",
      pie_1: {
        day: 0,
        hour: 0,
        num: 0,
      },
      pie_3: {
        num: 3,
        num1: 2,
      },
      userNums: {
        wddb: 0,
        blz: 0,
        ybj: 0,
        wdzx: 0,
      },
      roleAuthFlag: [true, true, true],
      heightFlag: 0, //容器高度
      heightFlag_0: 0, //无应用判断
      newsList: "",
      newsMore: "",
      noBs: false,
      loginState: false,
      top1: 0,
      top2: 0,
      top3: 0,
      height: "",
    };
  },
  mounted() {
    // this.drawPie(4, "pie4", "16");
    // this.drawPie(2, 'pie2', "32")
    // this.drawPies2()
    // this.getGuideline1()
    this.getDepartList();
    //获取底部统计
    // this.getStatistics();
    // this.getBjNums(2);
    this.getDepartNew();
    if (this.$store.state.isLogin) {
      this.loginState = true;
      this.getGuideline1();
      this.getUserNums();
      this.getpart1();
    } else {
      this.getGuideline();
      this.getpart();
    }
  },
  methods: {
    /**
     * @name getProcessStatistical
     * @description 获取各主题统计信息
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-18 10:48:46
     */
    async getProcessStatistical() {
      // /web/serviceStatistical/getProcessStatistical
      let res = null;
      try {
        res = await request({
          method: "get",
          url: "/portal-ywtb/web/serviceStatistical/getProcessStatistical",
        });
      } catch (error) {
        //
        return;
      }
      for (let item of res.data || []) {
        const index = this.typeOfService.findIndex(
          (vo) => item.sceneCode === vo.id
        );
        if (index > -1) {
          this.$set(this.typeOfService[index], "ybj", item.ybj);
          this.$set(this.typeOfService[index], "blz", item.blz);
          this.$set(this.typeOfService[index], "fwcs", item.visit_num);
        }
      }
    },
    ReturnTable(index) {
      let number = this[`TabTitIdx${index}`];
      return number;
    },
    changeService(index, flag) {
      if (flag == "true") {
        this.serviceIndex = index;
      } else {
        // this.$message({
        //   message: '暂时未有相关服务提供，如有问题，请联系管理员！',
        //   type: 'warning'
        // });
      }
    },
    mouseenter(name, index, flag) {
      if (flag == "true") {
        const i = this.getGuidelineList.findIndex(
          (item) => item.pcGuidelineSceneName === name
        );
        const obj = JSON.parse(JSON.stringify(this.getGuidelineList[i]));
        this.getGuidelineList.splice(i, 1);
        this.getGuidelineList.unshift(obj);
        this.serviceIndex = index;
      }
    },
    tab0click(index, idx, cCode, pCode) {
      let flage = this.heightFlag;
      this.heightFlag = 0;
      this[`cCode${index}`] = cCode;
      this[`pCode${index}`] = pCode;
      this[`TabTitIdx${index}`] = idx;
      this.heightFlag = flage;
    },
    tab1click(idx, cCode, pCode) {
      let flage = this.heightFlag;
      this.heightFlag = 0;
      (this.cCode1 = cCode), (this.pCode1 = pCode), (this.TabTitIdx1 = idx);
      this.heightFlag = flage;
    },
    tab2click(idx, cCode, pCode) {
      let flage = this.heightFlag;
      this.heightFlag = 0;
      (this.cCode2 = cCode), (this.pCode2 = pCode), (this.TabTitIdx2 = idx);
      this.heightFlag = flage;
    },
    // 好差评统计,各类事项占比
    drawPie000(flag, dom, legendTop) {
      var myChart = this.$echarts.init(document.getElementById(dom));
      var colorList, data, value;
      if (flag == 4) {
        colorList = ["#30AAF2", "#01D285", "#FDBA39", "#6F4DEA", "#FF3F3F"];
        data = ["非常满意", "满意", "基本满意", "不满意", "非常不满"];
        value = [
          {
            value: 90,
            name: "非常满意",
          },
          {
            value: 23,
            name: "满意",
          },
          {
            value: 27,
            name: "基本满意",
          },
          {
            value: 9,
            name: "不满意",
          },
          {
            value: 4,
            name: "非常不满",
          },
        ];
      } else if (flag == 2) {
        colorList = ["#6F4DEA", "#FDBA39", "#30AAF2", "#01D285"];
        data = [
          this.typeOfService[0].sname,
          this.typeOfService[1].sname,
          this.typeOfService[2].sname,
        ];
        value = [
          {
            value: this.typeOfService[0].totalNum,
            name: this.typeOfService[0].sname,
          },
          {
            value: this.typeOfService[1].totalNum,
            name: this.typeOfService[1].sname,
          },
          {
            value: this.typeOfService[2].totalNum,
            name: this.typeOfService[2].sname,
          },
          // {
          //   value: 33,
          //   name: '公开公示类'
          // }
        ];
      }
      var option = {
        title: {
          show: false,
          text: "各类事项数量占比",
          textStyle: {
            color: "#fff",
            fontSize: "16",
            fontFamily: "MicrosoftYaHei",
          },
          left: "150",
          top: "15",
          // textAlign:'center'
        },
        grid: {
          bottom: 120,
          left: 0,
          right: "10%",
        },
        legend: {
          show: true,
          orient: "vertical",
          top: legendTop,
          right: "20",
          icon: "circle",
          textStyle: {
            fontSize: 16,
            rich: {
              name: {
                color: "#fff",
                // align: 'right'
                // width: 60
              },
              percent: {
                color: colorList,
                fontSize: 18,
                padding: [0, 5, 0, 10],
                // align: 'right'
              },
            },
          },
          formatter: function (name) {
            // 获取legend显示内容
            let data = option.series[0].data;
            let total = 0;
            let tarValue = 0;
            for (let i = 0, l = data.length; i < l; i++) {
              total += data[i].value;
              if (data[i].name == name) {
                tarValue = data[i].value;
              }
            }
            let percent = ((tarValue / total) * 100).toFixed(2);
            return "{name| " + name + "}{percent|" + percent + "%}";
          },
          data: data,
        },
        series: [
          // 主要展示层的
          {
            radius: ["15%", "75%"],
            center: ["28%", "50%"],
            type: "pie",
            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex];
                },
              },
            },
            label: {
              normal: {
                show: false,
              },
            },
            data: value,
          }, // 边框的设置
          {
            radius: ["86%", "88%"],
            center: ["28%", "50%"],
            type: "pie",
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            animation: false,
            tooltip: {
              show: false,
            },
            itemStyle: {
              normal: {
                color: "rgb(0, 157, 233,.34)",
              },
            },
            data: [
              {
                value: 1,
              },
            ],
          },
        ],
      };
      myChart.setOption(option);
    },
    drawPies2() {
      var myChart = this.$echarts.init(document.getElementById("pie3"));
      var data = [20, 80];
      var placeHolderStyle = {
        normal: {
          label: {
            // show: false
          },
          labelLine: {
            // show: false
          },
          color: "rgba(0,0,0,0)",
          borderWidth: 0,
        },
        // emphasis: {
        // color: "rgba(0,0,0,0)",
        // borderWidth: 0
        // }
      };
      var dataStyle = {
        normal: {
          position: "center",
          show: true,
          textStyle: {
            fontSize: "24",
            fontWeight: "normal",
            color: "#fff",
          },
          formatter(v) {
            return (
              Math.round((v.value / (data[0] + data[1])) * 10000) / 100.0 + "%"
            );
          },
        },
      };
      let option = {
        // backgroundColor: '#fff',
        title: [
          {
            text: "已入住事项",
            subtext: "7789 项",
            subtextStyle: {
              color: "#fff",
            },
            left: "29.8%",
            top: "68%",
            textAlign: "center",
            textStyle: {
              fontWeight: "normal",
              fontSize: "16",
              color: "#fff",
              textAlign: "center",
            },
          },
          {
            text: "未入住事项",
            subtext: "7789 项",
            subtextStyle: {
              color: "#fff",
            },
            left: "70%",
            top: "68%",
            textAlign: "center",
            textStyle: {
              color: "#fff",
              fontWeight: "normal",
              fontSize: "16",
              textAlign: "center",
            },
          },
        ],
        //第一个图表
        series: [
          {
            type: "pie",
            hoverAnimation: false, //鼠标经过的特效
            radius: ["45%", "59%"],
            center: ["30%", "45%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: true,
              },
            },
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: 100,
                itemStyle: {
                  normal: {
                    color: "#009de91a",
                  },
                },
              },
              {
                value: 35,
                itemStyle: placeHolderStyle,
              },
            ],
          },
          //上层环形配置
          {
            type: "pie",
            hoverAnimation: false, //鼠标经过的特效
            radius: ["45%", "55%"],
            center: ["30%", "45%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false,
              },
            },
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: data[0],
                itemStyle: {
                  normal: {
                    color: "#00C0FF",
                  },
                },
                label: dataStyle,
              },
              {
                value: data[0] + data[1],
                itemStyle: placeHolderStyle,
              },
            ],
          },

          //第二个图表
          {
            type: "pie",
            hoverAnimation: false,
            radius: ["45%", "59%"],
            center: ["70%", "45%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false,
              },
            },
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: 100,
                itemStyle: {
                  normal: {
                    color: "#009de91a",
                  },
                },
              },
              {
                value: 35,
                itemStyle: placeHolderStyle,
              },
            ],
          },

          //上层环形配置
          {
            type: "pie",
            hoverAnimation: false,
            radius: ["45%", "55%"],
            center: ["70%", "45%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false,
              },
            },
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: data[1],
                itemStyle: {
                  normal: {
                    color: "#00D6A6",
                  },
                },
                label: dataStyle,
              },
              {
                value: data[0] + data[1],
                itemStyle: placeHolderStyle,
              },
            ],
          },
        ],
      };
      myChart.setOption(option);
    },
    goDepartPage(name, code) {
      localStorage.setItem("departName", name);
      localStorage.setItem("departCode", code);
      this.$router.push({
        path: "/depart",
        query: {
          code: code,
          // name: window.encodeURIComponent(name)
        },
      });
    },
    viewGuide(item, code) {
      if (item.pcGuidelineTypeId == 3 && item.portalPcHandlingGuideline == 0) {
        window.open(item.portalPcHandlingGuidelineUrl);
      } else {
        this.$router.push({
          path: "/guide",
          query: {
            code,
          },
        });
      }
    },
    byTheme(code, parentCode) {
      localStorage.setItem("pcGuidelineSceneCode", code);
      localStorage.setItem("pcGuidelineSceneParentCode", parentCode);
      this.$router.push("/search");
    },
    //获取主题
    getpart() {
      let sendData = qs.stringify({
        parentCode: "root",
      });
      this.ywtbRequest(
        "/portal-ywtb/web/guidelineScene/getGuidelineSceneList",
        sendData
      ).then((res) => {
        let data = res.dataList;
        let temp = [];
        for (let i = 0; i < data.length; i++) {
          for (let k = 0; k < data[i].sceneList.length; k++) {
            temp.push(data[i].sceneList[k]);
          }
        }
        this.ztList = temp;
      });
    },
    //登录后获取主题
    getpart1() {
      let sendData = qs.stringify({
        sceneParentCode: "root",
      });
      this.ywtbRequest(
        "/portal-ywtb/web/guideline/findGuidelineSceneList",
        sendData
      ).then((res) => {
        let data = res.dataList;
        let temp = [];
        for (let i = 0; i < data.length; i++) {
          for (let k = 0; k < data[i].sceneList.length; k++) {
            temp.push(data[i].sceneList[k]);
          }
        }
        this.ztList = temp;
        // console.log(this.ztList)
      });
    },
    //获取新闻
    getDepartNew() {
      let sendData = qs.stringify({
        deptCode: -1,
      });
      this.ywtbRequest(
        "/portal-ywtb/web/news/findNewsByDeptCode",
        sendData
      ).then((res) => {
        var data = res.dataList;
        this.newsMore = res.data;
        if (data.length === 0) {
          this.noBs = true;
        }
        let data1 = [];
        let len;
        if (data.length > 7) {
          len = 7;
        } else {
          len = data.length;
        }
        for (let i = 0; i < len; i++) {
          data1.push(data[i]);
          data1[i].newDate = data[i].date.substring(5);
        }
        this.newsList = data1;
      });
    },
    // 新闻跳转
    newsJump(url) {
      window.open(url);
    },
    //获取首页的事项列表
    getGuideline() {
      let sendData = qs.stringify({
        sceneParentCode: "root",
        pageNumber: 0,
        pageSize: 9,
      });
      this.ywtbRequest(
        "/portal-ywtb/web/guideline/findPortalHandlingGuidelineByScene",
        sendData
      ).then((res) => {
        this.listFlag = true;
        let data = res.dataList;
        // console.log(data)
        for (let i = 0; i < data.length; i++) {
          let data1 = data[i].sceneList;
          for (let j = 0; j < data1.length; j++) {
            let data2 = data1[j].guidelineList;
            for (let k = 0; k < data2.length; k++) {
              // data2[k].portalPcHandlingGuidelineImg =
              //   '/portal-ywtb/public/getImg?path=' + encodeURI(data2[k].portalPcHandlingGuidelineImg)
              data2[
                k
              ].portalPcHandlingGuidelineImg = `/portal-ywtb/${data2[k].portalPcHandlingGuidelineImg}`;
            }
          }
        }

        let list = data;
        list.map((item, index) => {
          item.index = index;
          this[`cCode${index}`] = item.sceneList[0].pcGuidelineSceneCode;
          this[`pCode${index}`] = item.sceneList[0].pcGuidelineSceneParentCode;
        });
        this.getGuidelineList = list;
        let typeOfService = [...this.typeOfService];
        typeOfService.forEach((result, index) => {
          data.map((el, i) => {
            if (result.sname == el.pcGuidelineSceneName) {
              result.sname = el.pcGuidelineSceneName;
              result.totalNum = el.count;
              result.pcGuidelineSceneCode = el.pcGuidelineSceneCode;
              result.isShow = "true";
              result.id = el.id;
              /**
               * @description 改成全等号，以排除0==''的情况
               * @author cjs1992
               * @date 2020-08-25 13:56:48
               */
              if (this.serviceIndex === "") {
                this.serviceIndex = index;
              }
            }
          });
        });
        /**
         * @description 改成全等号，以排除0==''的情况
         * @author cjs1992
         * @date 2020-08-25 13:56:48
         */
        if (this.serviceIndex === "") {
          this.serviceIndex = 0;
        }
        this.typeOfService = typeOfService;
        this.getProcessStatistical();
        //					for(let i = 0; i < 3; i++) {
        //						this.typeOfService[i].sname = data[i].pcGuidelineSceneName
        //						this.typeOfService[i].totalNum = data[i].count
        //						this.typeOfService[i].pcGuidelineSceneCode = data[i].pcGuidelineSceneCode
        //						this.typeOfService[i].isShow = "true"
        //					}

        // this.drawPie(2, "pie2", "32");
      });
    },
    //获取首页的事项列表登录后
    getGuideline1() {
      let data = "";
      if (this.$store.state.roleName != null) {
        for (let i = 0; i < this.$store.state.roleName.length; i++) {
          if (i == this.$store.state.roleName.length - 1) {
            data += this.$store.state.roleName[i].id;
          } else {
            data += this.$store.state.roleName[i].id + ",";
          }
        }
      }
      let sendData = qs.stringify({
        sceneParentCode: "root",
        roleList: data,
      });
      this.ywtbRequest(
        "/portal-ywtb/web/guideline/findPortalHandlingGuidelineBySceneLogin",
        sendData
      ).then((res) => {
        this.listFlag = true;
        let data = res.dataList;
        // console.log(data)
        for (let i = 0; i < data.length; i++) {
          let data1 = data[i].sceneList;
          for (let j = 0; j < data1.length; j++) {
            let data2 = data1[j].guidelineList;
            for (let k = 0; k < data2.length; k++) {
              // data2[k].portalPcHandlingGuidelineImg =
              //   '/portal-ywtb/public/getImg?path=' + encodeURI(data2[k].portalPcHandlingGuidelineImg)
              data2[
                k
              ].portalPcHandlingGuidelineImg = `/portal-ywtb/${data2[k].portalPcHandlingGuidelineImg}`;
            }
          }
        }
        let list = data;
        list.map((item, index) => {
          item.index = index;
        });
        this.getGuidelineList = list;
        let typeOfService = [...this.typeOfService];
        typeOfService.forEach((result, index) => {
          data.map((el, i) => {
            if (result.sname == el.pcGuidelineSceneName) {
              result.sname = el.pcGuidelineSceneName;
              result.totalNum = el.count;
              this.cCode0 = el.sceneList[i].pcGuidelineSceneCode;
              this.pCode0 = el.sceneList[i].pcGuidelineSceneParentCode;
              result.isShow = el.isShow;
              result.id = el.id;
              if (result.isShow == "true") {
                if (this.serviceIndex == "") {
                  this.serviceIndex = index;
                }
                this.heightFlag += 1;
              } else {
                this.roleAuthFlag[i] = false;
                this.heightFlag_0 -= 1;
              }
            }
          });
        });
        if (this.serviceIndex == "") {
          this.serviceIndex = 0;
        }
        this.typeOfService = typeOfService;
        //					for(let i = 0; i < data.length; i++) {
        //						this.typeOfService[i].sname = data[i].pcGuidelineSceneName
        //						this.typeOfService[i].totalNum = data[i].count
        //						this.typeOfService[i].isShow = data[i].isShow
        //						this.cCode0 = data[i].sceneList[i].pcGuidelineSceneCode
        //						this.pCode0 = data[i].sceneList[i].pcGuidelineSceneParentCode
        //						if(data[i].isShow == 'true') {
        //							this.serviceIndex = i
        //							this.heightFlag += 1
        //						} else {
        //							this.roleAuthFlag[i] = false
        //							this.heightFlag_0 -= 1
        //						}
        //					}
        // console.log(this.typeOfService)
        if (this.heightFlag_0 === -3) {
          this.serviceIndex = 4;
        }
        this.getProcessStatistical();
        // this.drawPie(2, "pie2", "32");
      });
    },
    // 获取事项数量统计登陆后
    getHomeCount() {
      this.ywtbRequest(
        "/portal-ywtb/web/indexStatistics/countGuidelineByType"
      ).then((res) => {
        let data = res.dataList;
        for (let i = 0; i < 3; i++) {
          this.typeOfService[i].sname = data[i].pcGuidelineSceneName;
          this.typeOfService[i].totalNum = data[i].count;
          this.typeOfService[i].isShow = data[i].isShow;
        }
        // this.drawPie(2, "pie2", "32");
      });
    },
    //获取用户部门角色
    getUserBaseInfo() {
      let sendData = qs.stringify({
        userCode: this.userId,
      });
      this.ywtbRequest(
        "/portal-ywtb/web/userfind/findUserRoleAndDept",
        sendData
      ).then((res) => {
        let data = res.data;
        this.nickName = data.name;
        this.rolename = data.rolename;
        this.departName = data.deptname;
      });
    },
    // 获取首页按部门部门列表
    getDepartList() {
      this.ywtbRequest(
        "portal-ywtb/web/portalPcGuidelineDepartmentGuideline/findDepartmentHandlingGuidelineNumList",
        "{}"
      ).then((res) => {
        // let totalNum = 0
        let data = res.dataList || [];
        // for (let index = 0; index < data.length; index++) {
        //   totalNum += data[index].num
        // }
        // let TempData = {
        //   "deptName": "全部",
        //   "num": totalNum,
        //   "deptCode": "deptCode"
        // }
        // data.unshift(TempData)
        this.departList = data.slice(1);
      });
      // let sendData = qs.stringify({
      //   mainDept: ""
      // });
      // this.ywtbRequest(
      //   "/portal-ywtb/web/portalPcGuidelineDepartmentGuideline/findDeptList"
      // ).then((res) => {
      //   let data = res.dataList;
      //   this.departList = data;
      // });
    },
    // 查看更多
    viewMore(code, parentCode) {
      localStorage.setItem("pcGuidelineSceneCode", code);
      localStorage.setItem("pcGuidelineSceneParentCode", parentCode);
      this.$router.push("/search");
    },
    goUser(site0, site1) {
      if (site0 != undefined) {
        localStorage.setItem("userSite0", site0);
        localStorage.setItem("userSite1", site1);
      }
      this.$router.push("/user");
    },
    //服务成效统计*********************************
    getStatistics() {
      // 各类事项占比
      // this.ywtbRequest('/portal-ywtb/web/indexStatistics/guidelineTypeRatio').then(res => {
      //   this.drawPie(2, 'pie2', "32", )
      // })
      // 平均办理时长
      this.ywtbRequest("/portal-ywtb/web/indexStatistics/avgHandleTime").then(
        (res) => {
          // this.drawPies1(res.data)
          let time = res.data.avgTime;
          this.pie_1.num = res.data.guidelinbCount;
          let arr = time.split("天");
          this.pie_1.day = arr[0];
          let arr_1 = arr[1].split("小时");
          this.pie_1.hour = arr_1[0];
        }
      );
      this.ywtbRequest(
        "/portal-ywtb/web/indexStatistics/findSuggestionRatio"
      ).then((res) => {});
    },
    // 今日办理数量,今日办结数量
    getBjNums(flag) {
      Date.prototype.Format = function (fmt) {
        var o = {
          "M+": this.getMonth() + 1, //月份
          "d+": this.getDate(), //日
          "h+": this.getHours(), //小时
          "m+": this.getMinutes(), //分
          "s+": this.getSeconds(), //秒
          "q+": Math.floor((this.getMonth() + 3) / 3), //季度
          S: this.getMilliseconds(), //毫秒
        };
        if (/(y+)/.test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
        return fmt;
      };
      let daySart = new Date(
        new Date(new Date().toLocaleDateString()).getTime()
      );
      let dayEnd = new Date(
        new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      );
      let sendData = qs.stringify({
        startTime: daySart.Format("yyyy-MM-dd hh:mm:ss"),
        endTime: dayEnd.Format("yyyy-MM-dd hh:mm:ss"),
        status: flag,
      });
      this.ywtbRequest(
        "/portal-ywtb/web/indexStatistics/findGuidelineByProcessTime",
        sendData
      ).then((res) => {
        // console.log(res)
      });
    },
    //获取角色映射关系
    getRoleAuth() {
      let data = "";
      for (let i = 0; i < this.$store.state.roleName.length; i++) {
        data += this.$store.state.roleName[i].id;
      }
      let sendData = qs.stringify({
        roleList: data,
      });
      this.ywtbRequest(
        "/portal-ywtb/web/guidelineScene/findRoleSceneList",
        sendData
      ).then((res) => {
        let data = res.dataList;
        let data1 = [];
        for (let i = 0; i < data.length; i++) {
          data1.push(data[i].pcGuidelineSceneRoleSceneCode);
        }
        this.roleAuthData = data1;
        console.log(this.typeOfService);
        for (let i = 0; i < this.typeOfService.length; i++) {
          console.log(data1[0]);
          console.log(this.typeOfService[i].pcGuidelineSceneCode);
          if (this.typeOfService[i].pcGuidelineSceneCode == data1[0]) {
            this.serviceIndex = i;
            this.roleAuthFlag[i] = true;
          } else {
            this.roleAuthFlag[i] = false;
          }
        }
      });
    },
    // 获取用户办事数量
    getUserNums() {
      let sendData = qs.stringify({
        userCode: this.$store.state.userCode,
      });
      this.ywtbRequest("/portal-ywtb/web/guideline/countGuidelineByScene").then(
        (res) => {
          let data = res.dataList;
          for (let i = 0; i < data.length; i++) {
            if (data[i].status == "办理中") {
              this.userNums.blz = data[i].count;
            } else if (data[i].status == "已办结") {
              this.userNums.ybj = data[i].count;
            }
          }
        }
      );
      this.getNewMsg0();
      this.getWddbMsg();
    },
    // 获取我的咨询新动态数量
    getNewMsg0() {
      let sendData = qs.stringify({
        memberId: this.$store.state.userId,
      });
      this.ywtbRequest(
        "/portal-ywtb/web/consultation/findNewConsultationByMemberId",
        sendData
      ).then((res) => {
        this.userNums.wdzx = res.count;
      });
    },
    // 获取我的待办个数
    getWddbMsg() {
      let sendData = qs.stringify({
        pageNum: 1,
        pageSize: 10,
        resultType: 0,
      });
      this.ywtbRequest("/portal-ywtb/web/process/findWork", sendData).then(
        (res) => {
          this.userNums.wddb = res.count;
        }
      );
    },
  },
  watch: {
    "$store.state.isLogin"() {
      // this.getGuideline1()
      // this.getUserNums()
      // this.getpart1()
      // this.getHomeCount()
    },
    typeOfService(val) {
      // console.log(this.typeOfService)
    },
  },
};
</script>

<style lang="scss" scoped>
.grxx {
  width: 380px;
  overflow: hidden;
}
.grxx .userMatterList li {
  float: left;
  margin-right: 7px;
  width: 82px;
  height: 64px;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
}
.grxx .userMatterList li.marginR0 {
  margin-right: 0;
}
.poTop {
  top: 0 !important;
}

.poMiddle {
  top: 360px !important;
}

.poBottom {
  top: 720px !important;
}

#pie1 {
  padding: 10px 20px;
}

#pie1 .bt1 {
  width: 126px;
  height: 126px;
  float: left;
  border-radius: 50%;
  background-color: #2ac2f5;
  position: relative;
  margin: 10px;
  cursor: pointer;
}

#pie1 .bt1:hover {
  background-color: #17c1fa;
}

#pie1 .bt2 {
  width: 126px;
  height: 126px;
  border-radius: 50%;
  float: right;
  background-color: #00d6a6;
  position: relative;
  margin: 10px;
  cursor: pointer;
}

#pie1 .bt2:hover {
  background-color: #09e2b3;
}

.insidePie {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #324f9b;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#pie1 .bt1 p {
  text-align: center;
  color: #fff;
  position: absolute;
  z-index: 2;
  width: 126px;
}

#pie1 .bt1 p b {
  color: #00c0ff;
  display: inline-block;
  padding: 0 4px;
  font-size: 18px;
}

#pie1 .bt1 p:nth-child(2) {
  top: 40px;
}

#pie1 .bt1 p:last-child {
  top: 70px;
}

#pie1 .bt2 p {
  text-align: center;
  position: absolute;
  z-index: 2;
  width: 126px;
  font-size: 18px;
}

#pie1 .bt2 p:nth-child(2) {
  top: 40px;
  color: #00d6a6;
  font-size: 24px;
  font-weight: 700;
}

#pie1 .bt2 p:last-child {
  top: 70px;
  color: #fff;
}

#pie3 {
  padding: 10px 30px;
}

#pie3 .bt1 {
  width: 126px;
  height: 126px;
  border-radius: 50%;
  float: left;
  background-color: #00c0ff;
  position: relative;
  margin: 10px;
  cursor: pointer;
}

#pie3 .bt2 {
  width: 126px;
  height: 126px;
  border-radius: 50%;
  float: right;
  background-color: #00d6a6;
  position: relative;
  margin: 10px;
  cursor: pointer;
}

#pie3 .bt1 p,
#pie3 .bt2 p {
  text-align: center;
  position: absolute;
  z-index: 2;
  width: 126px;
  font-size: 18px;
}

#pie3 .bt2 p:nth-child(2),
#pie3 .bt1 p:nth-child(2) {
  top: 40px;
  color: #00d6a6;
  font-size: 24px;
  font-weight: 700;
}

#pie3 .bt1 p:nth-child(2) {
  color: #00c0ff;
}

#pie3 .bt2 p:last-child,
#pie3 .bt1 p:last-child {
  top: 70px;
  color: #fff;
}

.serviceContent.height_0 {
  height: 20px;
}

.serviceContent.height_1 {
  /* height: 370px; */
  height: auto;
}

.serviceContent.height_2 {
  /* height: 740px; */
  height: auto;
}

.noData {
  text-align: center;
  padding-top: 60px;
}

.noData p {
  margin-top: 30px;
  font-size: 16px;
  color: #666;
}

.bsqsData.noData {
  padding-top: 20px;
}

.serviceContent .serviceContentBox.static {
  width: 100%;
  height: auto;
  position: static;
  min-height: 360px;
  padding-bottom: 20px;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
.drag_item {
  transition: all 0.3s;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
.list-complete-move {
  transition: transform 0.8s;
}
.mutil-line-ellipsis {
  width: 100%;
  height: 40px;
  line-height: 20px;
  // margin: 20px 20px 50px 300px;
  border: 0px solid #aaa;
  line-height: 20px;
  overflow: hidden;
}
.guideline_image {
  margin-top: 20px;
}
/*相当于之前的prop*/
.mutil-line-ellipsis:before {
  content: "";
  float: left;
  width: 5px; /*缩小宽度为5px，其余属性不变*/
  height: 50px;
}
/*相当于之前的main*/
.mutil-line-ellipsis > :first-child {
  float: right;
  width: 100%;
  margin-left: -5px; /*让main元素左移5px，这样main元素在宽度上就完全占满了父元素；*/
  word-break: break-all;
}
/*相当于之前的realEnd*/
.mutil-line-ellipsis:after {
  content: "...";
  box-sizing: content-box;
  float: right;
  position: relative;
  width: 50px;
  height: 25px;
  top: -28px; /*等于高度的负值，就是文字的行高*/
  left: 100%;
  /*而设置margin-left: -50px、padding-right: 5px则是为了让realend元素的盒模型的最终宽度计算为5px。*/
  margin-left: -50px;
  padding-right: 5px;
  font-size: 13px;
  text-align: right;
  // background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff 40px);
  background-color: #fff;
  width: 25px;
  margin-left: -25px;
  text-align: left;
  text-indent: 5px;
}

dd.active.active_1 {
  background-color: #e91a22;
}
dd.active_1:hover {
  color: #e91a22;
}
// dd.active_1.active:hover {
//   color: #fff;
// }
dd.active.active_2 {
  background-color: #4566e0;
}
dd.active_2:hover {
  color: #4566e0;
}
dd.active_2.active:hover {
  background-color: #4566e0;
  color: #fff;
}
dd.active.active_3 {
  background-color: #00cc9e;
}
dd.active_3:hover {
  color: #00cc9e;
}
// dd.active.active_3:hover {
//   background-color: #fff;
// }
.hover_wrap {
  position: relative;
  float: right;
  width: 50px;
  height: 42px;
  top: 0px;
  img {
    top: 10px !important;
    right: 0 !important;
  }
  &:hover {
    .directHoverlist {
      display: block;
      top: 45px;
      left: -105px;
      .redTriangle {
        left: 130px;
      }
      &.theme_wrap {
        left: -238px;
        .redTriangle {
          left: 265px;
        }
      }
      li:hover {
        color: #fff;
      }
    }
  }
}
.topQuery .notLogin .directBox > div {
  overflow: visible;
}
.overflowHidden {
  height: 258px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue